const CREDENTIAL_SUFFIXES = new Set([
  "RN",
  "SW",
  "NP",
  "PCC",
  "CHAPLAIN",
  "CHAPLIAN",
  "PA",
  "CHAP",
  "OTA",
  "PT",
  "PTA",
  "OT",
  "LPN",
  "LPN-A",
  "LPN-C",
  "LPN-R",
]);

function titleCaseWord(word: string): string {
  if (!word) return word;
  return word.charAt(0).toUpperCase() + word.slice(1).toLowerCase();
}

/**
 * For Compassus navigator provider display: omit empty / literal "null";
 * title-case name tokens; keep recognized credential suffixes uppercase.
 */
export function normalizeCompassusProviderName(
  raw: string | null | undefined
): string | null {
  if (raw == null) return null;
  const trimmed = raw.trim();
  if (!trimmed || trimmed.toLowerCase() === "null") return null;

  const words = trimmed.split(/\s+/).filter(Boolean);
  if (words.length === 0) return null;

  const last = words[words.length - 1];
  const lastKey = last.toUpperCase();

  if (CREDENTIAL_SUFFIXES.has(lastKey)) {
    if (words.length === 1) return lastKey;
    const namePart = words.slice(0, -1).map(titleCaseWord).join(" ");
    return `${namePart} ${lastKey}`;
  }

  return words.map(titleCaseWord).join(" ");
}
